import React, { Component, useId, useRef, useState } from 'react';
import { __ } from 'i18n/index';
import ActiveSelectableButton from 'react/elements/ActiveSelectableButton';

function DraftReplyPicker({ replies, replying, sendPostReply }) {
	const [open, setOpen] = useState(false);
	const trigger = useRef(null);
	const pickerId = useId();
	const titles = [
		__('Thank the reporter'),
		__('Dispute already reported'),
		__('Leaving friendlies'),
		__('Reminder about toxic warnings'),
		__('Explain toxic warnings'),
		__('Duplicate chat reports'),
		__('Report and ignore'),
		__('Request evidence')
	];
	const close = () => {
		setOpen(false);
		trigger.current?.focus();
	};

	return (
		<div className='bug-workspace-quick' onKeyDown={(event) => {
			if(open && event.key === 'Escape') {
				event.preventDefault();
				event.stopPropagation();
				close();
			}
		}}>
			<button ref={trigger} type='button' className='ui-button ui-button--small' aria-expanded={open} aria-controls={pickerId} disabled={replying} onClick={() => setOpen(!open)}>
				{__('Quick replies')} <span aria-hidden='true'>{open ? '▴' : '▾'}</span>
			</button>
			{open && <div id={pickerId} className='bug-workspace-quick-picker'>
				<p>{__('Choose a reply to edit before posting.')}</p>
				<ul className='bug-workspace-quick-options'>
					{replies.map((reply, index) => <li key={index}>
						<button type='button' disabled={replying} onClick={() => {
							sendPostReply(reply);
							close();
						}}>
							<strong>{titles[index]}</strong>
							<span>{reply}</span>
						</button>
					</li>)}
				</ul>
			</div>}
		</div>
	);
}

export default class PresetRepliesComponent extends Component {

	constructor(props) {
		super(props);
		this.sendReply = this.sendReply.bind(this);

		this.change = this.change.bind(this);
		this.replies = [
			'Thanks for the report!',
			'Thanks for the report. However, if there\'s a dispute, you don\'t need to report for the same reason.',
			'Thanks for the report! However, if someone is doing something annoying like this, you can just leave. It\'s friendlies!',
			'Thanks for the report! However, please pay more attention to toxic warnings in the future.',
			'Thanks for the report! However, please pay more attention to toxic warnings in the future. This system is in place so that people can voluntarily play against the few habitually toxic ' +
			'players on the site as opposed to them creating multiple UNMARKED accounts due to their main account being closed. Thanks for understanding and if you have any questions please feel free to respond!',
			'Thanks for the report! One is enough for chats.\n',
			'Thanks for the report! This person is definitely in the wrong, but for the future it\'s typically better to just report and ignore instead of being rude back.\n',
			'Thanks for the report! Make sure to provide evidence for issues that aren\'t present in the chat log though.'
		];
		this.state = {
			currentSelection: props.draftMode ? '' : 0
		};
	}

	change(event) {
		this.setState({
			currentSelection: event.target.value
		});
	}

	sendReply() {
		const { sendPostReply } = this.props;

		sendPostReply(this.replies[this.state.currentSelection]);
	}

	render() {
		const { replying, draftMode = false } = this.props;
		if(draftMode) {
			return <DraftReplyPicker replies={this.replies} replying={replying} sendPostReply={this.props.sendPostReply} />;
		}
		return (
			<div>
				<div className='form-group'>
					<ActiveSelectableButton
						disabled={replying}
						onClick={this.sendReply}
					>
						Post Quick Reply
					</ActiveSelectableButton>
				</div>
				<div className='form-group'>
					<select
						value={this.state.currentSelection}
						onChange={this.change}
						className='form-control'
					>
						{this.replies.map((reply, index) => {
							return (
								<option
									key={index}
									value={index}
								>
									{reply}
								</option>
							);
						})}
					</select>
				</div>
			</div>
		);
	}
}